import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "store/hooks";
import { setNotification } from "store/features/notificationSlice";
import { SubscriptionKeys } from "store/features/subscriptionSlice";

import {
  subscriptionTabs,
  TabId,
} from "pages/Subscriptions/Subscriptions/variables";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";
import { FbPixelAnalyticsEvents } from "shared/constants/fb-pixel-analytics";

const FREE_SUBSCRIPTION_PLAN_ID = 1;

export const useSubscriptionStatusHandler = (
  setVisibleTab: (tabId: string) => void
) => {
  const dispatch = useAppDispatch();

  const currentSubs = useAppSelector(
    (state) => state.subscription.subscription
  );

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const paymentStatus = params.get("payment_status");

    if (!currentSubs) {
      return;
    }

    const { isTrial, isCancelled, isExpired } = currentSubs || {};

    const { paymentPlan } = currentSubs;
    const currentTab = subscriptionTabs.find((tab) =>
      tab.subscriptions.some((card) =>
        card.plans.some(
          (plan) => plan.paymentPlanId === paymentPlan.paymentPlanId
        )
      )
    );
    setVisibleTab(currentTab ? currentTab.id : TabId.Monthly);

    const isSubsActive = !isCancelled && !isExpired;
    const isFreePlan =
      paymentPlan.paymentPlanId === FREE_SUBSCRIPTION_PLAN_ID && !isTrial;

    if (
      paymentStatus === "success" &&
      paymentPlan.name &&
      !isTrial &&
      isSubsActive
    ) {
      const defaultMsg =
        "Оплата пройшла успішно. Ваш Тариф використовує автопродовження передплати до моменту її скасування. Приємного користування сервісом IBAN oplata.";
      const freePlanMsg =
        "Вам активовано Безкоштовний тариф. Приємного користування сервісом IBAN oplata.";

      dispatch(
        setNotification({
          message: isFreePlan ? freePlanMsg : defaultMsg,
          severity: "success",
        })
      );
      localStorage.removeItem(SubscriptionKeys.PROMOCODE);
      localStorage.removeItem(SubscriptionKeys.PROMOCODE_TIMESTAMP);

      if (isFreePlan) {
        analytics().sendEvent(AnalyticsEvents.free_subscription_activated);
      } else {
        analytics().sendConversionEvent(FbPixelAnalyticsEvents.Purchase, {
          content_name: paymentPlan.name,
          value: paymentPlan.price,
        });
      }
    } else if (paymentStatus === "failed") {
      dispatch(
        setNotification({
          message:
            "Трапилась помилка при здійснені оплати. Зверніться в Службу підтримки для вирішення проблеми.",
          severity: "error",
        })
      );
    }

    window.history.replaceState(null, "", window.location.pathname);
  }, [currentSubs, dispatch, setVisibleTab]);
};
